import React from 'react'
import PropTypes from 'prop-types'

import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons'

const Payments = (props) => {
  const { provider, providerForm } = props

  const {
    entityState: {
      accounts_email,
      accounts_phone,
      bank_account_bsb,
      bank_account_name,
      bank_account_number,
    },
    handlers,
  } = providerForm

  const providerStripeName = digObject(provider, 'stripe_integration.data.name', '')
  const hasIntegration = !!provider.stripe_integration

  return (
    <DashboardModule title="Payments &amp; Accounts">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Accounts Email">
            <input name="accounts_email" type="text" value={accounts_email} {...handlers} />
          </Form.Field>

          <Form.Field label="Accounts Phone" marginTop={['large', 0]}>
            <input name="accounts_phone" type="text" value={accounts_phone} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="BSB">
            <input name="bank_account_bsb" type="text" value={bank_account_bsb} {...handlers} />
          </Form.Field>

          <Form.Field label="Account Number" marginTop={['large', 0]}>
            <input name="bank_account_number" type="text" value={bank_account_number} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Bank Account Name">
            <input name="bank_account_name" type="text" value={bank_account_name} {...handlers} />
          </Form.Field>

          <Form.Field
            boxProps={{ color: 'bodyFontLightColor' }}
            label="Credit Card Payments"
            marginTop={['large', 0]}
          >
            <Box position="relative" alignItems="center">
              <Box
                alignItems="center"
                bottom={0}
                justifyContent="center"
                left={8}
                position="absolute"
                top={0}
                width="fit-content"
              >
                <FontAwesomeIcon icon={hasIntegration ? faCheck : faTimes} />
              </Box>

              <input
                disabled
                style={{ paddingLeft: '26px' }}
                value={hasIntegration
                  ? `Linked to Stripe Account (${providerStripeName})`
                  : 'Not Linked to Stripe'}
              />
            </Box>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

Payments.propTypes = {
  provider: PropTypes.object.isRequired,
  providerForm: PropTypes.object.isRequired,
}

export default Payments
